import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Layout } from '@components';

const StyledHeader = styled.header`
  padding: calc(var(--nav-height) + 72px) 0 40px;
  background: var(--paper);
  border-bottom: 1px solid var(--line);
  background-image: radial-gradient(720px 380px at 90% -20%, rgba(86, 112, 246, 0.12), transparent 62%);

  h1 {
    margin: 0 0 14px;
    font-size: clamp(1.9rem, 3.6vw, 2.8rem);
  }

  .updated {
    margin: 0;
    color: var(--text-mute);
    font-family: var(--font-mono);
    font-size: var(--fz-xs);
  }

  @media (max-width: 768px) {
    padding: calc(var(--nav-height) + 48px) 0 32px;
  }
`;

/**
 * Оформление юридических документов.
 * ВАЖНО: юридический текст перед публикацией должен быть проверен
 * специалистом по законодательству РФ о персональных данных.
 */
const StyledBody = styled.div`
  ${({ theme }) => theme.mixins.container};
  max-width: 860px;
  padding-top: 56px;
  padding-bottom: 96px;

  @media (max-width: 768px) {
    padding-top: 36px;
    padding-bottom: 64px;
  }

  h2 {
    margin: 48px 0 16px;
    font-size: clamp(1.3rem, 2.4vw, 1.7rem);
  }

  h2:first-child {
    margin-top: 0;
  }

  h3 {
    margin: 28px 0 10px;
    font-size: var(--fz-lg);
  }

  p,
  li {
    color: var(--text-soft);
    line-height: 1.7;
  }

  p {
    margin: 0 0 14px;
  }

  ul,
  ol {
    margin: 0 0 18px;
    padding-left: 22px;

    li {
      margin-bottom: 8px;
    }
  }

  a {
    color: var(--blue);
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  strong {
    color: var(--text);
  }

  .requisites {
    margin-top: 40px;
    padding: 28px;
    border: 1px solid var(--line);
    border-radius: var(--radius-lg);
    background: var(--paper-soft);

    p:last-child {
      margin-bottom: 0;
    }
  }
`;

const LegalPage = ({ location, title, updated, description, children }) => (
  <Layout location={location} title={title} description={description}>
    <main>
      <StyledHeader>
        <div className="container">
          <p className="eyebrow">Правовая информация</p>
          <h1>{title}</h1>
          <p className="updated">Редакция от {updated}</p>
        </div>
      </StyledHeader>

      <StyledBody>{children}</StyledBody>
    </main>
  </Layout>
);

LegalPage.propTypes = {
  location: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  updated: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
};

LegalPage.defaultProps = {
  description: null,
};

export default LegalPage;
